import React from "react";
import { Button, Popover } from "@material-ui/core";
import { styles } from "./index.styles";
import { useSelector } from "react-redux";
import lockIcon from "../lock.png";
import premium from "../premium.png";
import { useHistory } from "react-router-dom";

/** @type {React.FC<import('../../typings').IHeaderDesktopProps>} */
const DesktopNav = ({ menuState, setMenuState }) => {
  const { accessLevel } = useSelector((state) => state.appReducer);
  const history = useHistory();

  const { anchorEl, anchorElStockMenu, anchorElOpenInterest, anchorWatchlist } =
    menuState;

  const open = Boolean(anchorEl);
  const stockopen = Boolean(anchorElStockMenu);
  const openInterestopen = Boolean(anchorElOpenInterest);
  const watchlistOpen = Boolean(anchorWatchlist);

  const navLinks = [
    {
      title: "Home",
      slug: "/home",
      open: open,
      mouseOver: this.handlePopoverOpen,
      mouseOut: this.handlePopoverClose,
      style: { ...styles.homeButton },
    },
    {
      title: "UOA",
      slug: "/unusualoptionsactivity",
      open: true,
      mouseOver: this.handlePopoverOpenStockMenu,
      mouseOut: this.handlePopoverStockClos,
      style: { ...styles.rightButton },
    },
    {
      title: "Stock",
      slug: "/stocks",
      open: stockopen,
      mouseOver: this.handlePopoverOpenStockMenu,
      mouseOut: this.handlePopoverStockClose,
      style: { ...styles.rightButton, marginLeft: "30px" },
    },
    {
      title: "New Options Chain",
      slug: "/optionschain",
      open: true,
      mouseOver: this.undefined,
      mouseOut: this.undefined,
      style: { ...styles.rightButton, marginLeft: "30px" },
    },
    {
      title: "Open Interest",
      slug: "/openinterest",
      open: openInterestopen,
      mouseOver: this.handlePopoverOpenInterest,
      mouseOut: this.handlePopoverOpenInterestClose,
      style: { ...styles.rightButton, marginLeft: "30px" },
    },
    {
      title: "Watchlist",
      slug: "/watchlist",
      open: watchlistOpen,
      mouseOver: this.handlePopoverWatchlist,
      mouseOut: this.handlePopoverWatchlistClose,
      style: { ...styles.rightButton, marginLeft: "30px" },
    },
  ];

  const protectedRoutes = ["/home", "/stocks", "/watchlist", "/openinterest"];

  return (
    <div style={styles.buttonWrapper}>
      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "flex-start",
        }}
      >
       {
  navLinks.map(({ title, slug, open, mouseOver, mouseOut, style }) => (
    <Button
      key={slug}
      style={{ ...style }}
      onClick={(event) => {
        if (accessLevel === "fullaccess" || accessLevel === "halfaccess") {
          history.push(slug);
        }
        setMenuState({ ...menuState, anchorEl: null });
      }}
    >
      {protectedRoutes.includes(slug) ? (
        <div>
          <div style={styles.hoverDiv}>
            <div
              aria-owns={open ? "mouse-over-popover" : undefined}
              aria-haspopup="true"
              onMouseOver={mouseOver}
              onMouseOut={mouseOut}
            >
              {title}
            </div>
            {accessLevel === "halfaccess" && (
              <Popover
                id="mouse-over-popover"
                open={open}
                anchorEl={menuState.anchorElHover}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                onClose={mouseOut}
                disableRestoreFocus
              >
                <div style={{ width: "250px" }}>
                  <img
                    height="100%"
                    width="100%"
                    src={premium}
                    alt="test"
                  />
                </div>
              </Popover>
            )}

            {accessLevel === "halfaccess" && (
              <div style={styles.lockButton}>
                <img height="100%" width="100%" src={lockIcon} alt="" />
              </div>
            )}
          </div>
        </div>
      ) : (
        title
      )}
    </Button>
  ))
}


        {accessLevel === "halfaccess" && (
          <a
            href="https://bit.ly/3IQTN4B"
            style={{ textDecoration: "none" }}
            rel="noopener noreferrer"
            target="_blank"
          >
            {" "}
            <Button
              style={{
                ...styles.rightButton,
                marginLeft: "30px",
                backgroundColor: "#02b1ef",
                borderRadius: "0px",
                height: "30px",
                marginTop: "5px",
                width: "100px",
              }}
            >
              Premium
            </Button>
          </a>
        )}
      </div>
    </div>
  );
};

export default DesktopNav;



// WEBPACK FOOTER //
// ./src/components/Header/DesktopNav.jsx